import { render, staticRenderFns } from "./FloorMapPalette.vue?vue&type=template&id=3a30563c"
import script from "./FloorMapPalette.vue?vue&type=script&lang=js"
export * from "./FloorMapPalette.vue?vue&type=script&lang=js"
import style0 from "./FloorMapPalette.vue?vue&type=style&index=0&id=3a30563c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports